import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from './components/Modal/index';
import { closeModal } from './store/actions';
import * as selectors from './store/selectors';


const asModal = ({ name, onCloseActionToDispatch, ...other }) => (WrappedComponent) => {
  class ReduxModal extends React.Component { // eslint-disable-line
    render() {
      return (
        <Modal contentLabel={name} name={name} {...other} {...this.props}>
          <WrappedComponent name={name} {...this.props} />
        </Modal>
      );
    }
  }

  const mapStateToProps = (state) => ({
    isOpen: selectors.getIsModalOpen(state, name),
    payload: selectors.getPayload(state, name),
  });

  const mapDispatchToProps = (dispatch, props) => ({
    onRequestClose: () => {
      if (props.onCloseActionToDispatch) {
        dispatch(props.onCloseActionToDispatch());
      }
      dispatch(closeModal(name));
    },
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ReduxModal);
};
asModal.propTypes = {
  name: PropTypes.string.isRequired,
  onCloseActionToDispatch: PropTypes.func,
};
asModal.defaultProps = {
  onRequestClose: () => {},
};


export default asModal;
